// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"179":"8b4132ac","237":"8b4132ac","300":"8b4132ac","688":"1ffdf7f1","833":"8b4132ac","884":"d2f9cdc6","918":"8b4132ac","921":"8b4132ac"}[chunkId] + ".chunk.css";
};